import { db } from "../firebase/config";
import { collection, addDoc } from "firebase/firestore";

export const useCreate = () => {
  const ref = collection(db, "transportations");

  const createDocument = async (doc) => {
    try {
      await addDoc(ref, doc);
      console.log("Document successfully created!");
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return createDocument;
};
